export default __webpack_public_path__ + "static/media/frame_corner_top_right.6b9ff328.png";